import Components from './../Component';

export default class Ascenseur extends Components {

  constructor($) {
    super($);
    this.lang = $('body').attr('data-language');
  }

  init(index, element) {
    this.get(element);
  }

  get(element) {
    this.$.getJSON('/'+this.lang+'/ascenseur/realtime', function (data) {
      this.$(element).html(data.html);
      this.$(element).on('click', function () {
        if (!this.$(element).hasClass('disabled')) {
          this.get(element);
          this.$(element).addClass('disabled');
        }
        return false;

      }.bind(this));
    }.bind(this)).done(function () {
      this.$(element).removeClass('disabled');
    }.bind(this));
  }
}